import { render, staticRenderFns } from "./CurrencySelector.vue?vue&type=template&id=32f36b5e&scoped=true&"
import script from "./CurrencySelector.vue?vue&type=script&lang=ts&"
export * from "./CurrencySelector.vue?vue&type=script&lang=ts&"
import style0 from "./CurrencySelector.vue?vue&type=style&index=0&id=32f36b5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f36b5e",
  null
  
)

export default component.exports